import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";


export const GetOPDInvestigationDetailById = (params: any) =>
    GET_ENC(`${BASE_URL}/api/OPDInvestigation/GetDetail?` + params, null);

export const CreateOPDInvestigation = (data: any) =>
    POST_ENC(`${BASE_URL}/api/OPDInvestigation/Create`, data, true);

export const UpdateOPDInvestigation = (data: any) =>
    POST_ENC(`${BASE_URL}/api/OPDInvestigation/Update`, data, true);

export const DeleteOPDInvestigationDetail = (data: any) =>
    POST_ENC(`${BASE_URL}/api/OPDInvestigation/Delete`, data);

export const UpdateOPDInvestigationByTemplate = (data: any) =>
    POST_ENC(`${BASE_URL}/api/OPDInvestigation/UpdateByTemplate`, data);